/**
 * Absence ladder for FC quality_mode=low (FE-driven).
 * Port of FC agent coordinator/question.py::_absence_next_action thresholds.
 */

export const ABSENCE_CHECKIN_1_S = 15;
export const ABSENCE_CHECKIN_2_S = 30;
export const ABSENCE_FINALIZE_S = 45;
/** Silence since last voiced audio below this keeps the absence clock reset. */
export const ABSENCE_VOICED_RESET_S = 3;

export type AbsenceNextAction = 'wait' | 'checkin' | 'finalize';

/**
 * Escalera de ausencia: wait | checkin | finalize.
 * Never finalizes without two prior check-ins.
 */
export function absenceNextAction(
  absentFor: number,
  checkinsDone: number,
): AbsenceNextAction {
  if (absentFor >= ABSENCE_FINALIZE_S && checkinsDone >= 2) {
    return 'finalize';
  }
  const threshold = checkinsDone >= 1 ? ABSENCE_CHECKIN_2_S : ABSENCE_CHECKIN_1_S;
  if (absentFor >= threshold && checkinsDone < 2) {
    return 'checkin';
  }
  return 'wait';
}
